import React, { useState, useEffect } from 'react';
import useFetch from './hooks/useFetch';
import AudioPlayer from './components/AudioPlayer/AudioPlayer';
import ReactGA4 from 'react-ga4';
import TagManager from 'react-gtm-module';

import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';

function App() {
  const [isLoading, data, error, streamLink, retry] = useFetch();
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    ReactGA4.initialize('G-2THM9YM9RD');
    ReactGA4.send('pageview');
    TagManager.initialize({ gtmId: 'GTM-M7MT8PT' });
  }, []);

  useEffect(() => {
    const updateDimensions = () => setWidth(window.innerWidth);
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  return (
    <div className='main-container'>
      <Header />
      {error ? (
        <div className='main-container__error' role='alert'>
          <p className='main-container__error-text'>Nepavyko prisijungti prie radijo. Patikrinkite interneto ryšį.</p>
          <button className='main-container__error-btn' onClick={retry}>
            Bandyti dar kartą
          </button>
        </div>
      ) : isLoading ? (
        <div className='main-container__loading-text'>Kraunasi...</div>
      ) : (
        <AudioPlayer streamLink={streamLink} data={data} width={width} />
      )}
      <Footer width={width} />
    </div>
  );
}

export default App;
